export default "__VITE_ASSET__DTst_2EN__"